module.exports = __webpack_public_path__ + "img/header-memoireRingsAsWeddingRings@2x.6631084.webp";